<h1 mat-dialog-title data-test-id="outreach-email-confirmation-title">Email - {{ email.recipientAddress }}</h1>
<div mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div data-test-id="outreach-email-confirmation-sender" class="flex flex-row">
      <span class="basis-[148px]">Sender: </span>{{ email.senderEmail }}
    </div>
    <div data-test-id="outreach-email-confirmation-template-name" class="flex flex-row">
      <span class="basis-[148px]">Template: </span>{{ email.templateName }}
    </div>
    <div data-test-id="outreach-email-confirmation-subject" class="flex flex-row">
      <span class="basis-[148px]">Subject: </span>{{ email.templateContent.subject }}
    </div>
    <div data-test-id="outreach-email-confirmation-preheader" class="flex flex-row">
      <span class="basis-[148px]">Preheader: </span>{{ email.templateContent.preheader }}
    </div>
    <div data-test-id="outreach-email-confirmation-send-date" class="flex flex-row">
      <span class="basis-[148px]">Send date: </span>{{ email.sendTime | date: 'medium' }}
    </div>
    <div data-test-id="outreach-email-confirmation-honorarium" class="flex flex-row">
      <span class="basis-[148px]">Honorarium: </span>{{ email.honorarium }} ({{ email.currency }})
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <div class="flex flex-1 justify-end">
    <button mat-button mat-dialog-close data-test-id="outreach-email-confirmation-cancel-button">Cancel</button>
    <button
      matButton="filled"
      color="primary"
      cdkFocusInitial
      data-test-id="outreach-email-confirmation-confirm-button"
      [mat-dialog-close]="true"
    >
      Send email
    </button>
  </div>
</div>
